module.exports = __webpack_public_path__ + "static/mountain-left-e4086638cc8c52569ee94b0d0ec01c64.png";